import React from 'react';
import type { EventState } from '../fixtures/types';
import '../../app/App.css';

export const STATE_LABEL: Record<EventState, string> = {
  needsrev: 'Needs review',
  running: 'Running',
  blocked: 'Blocked',
  approved: 'Approved',
};

/** The governed-event state pill. One source of truth for state → label + color, reused across surfaces. */
export function StatePill({ state }: { state: EventState }): React.ReactElement {
  return <span className={`statePill state-${state}`}>{STATE_LABEL[state]}</span>;
}
